import { call } from './misc';

export const getCategories = (token: string, tokenId: string) =>
  call('/categories', 'GET', null, token, tokenId);

export default {
  getCategories
};
